import templateUrl from "emun.auth/change-password/change-password-prompt.htm";
import controller from "emun.auth/change-password/change-password.controller";
import open from "webmodals/open";

export default ({
  size = "md",
  backdrop = true,
  keyboard = true,
  token,
  resetId,
  id,
  userAuthId,
  title = "Change your password"
}) =>
  open({
    size,
    backdrop,
    keyboard,
    templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      title: () => title,
      request: () => ({ resetId, token, id, userAuthId })
    }
  }).result;
